// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__4-P9m","head":"ProcedureTableInfo_head__1f73P"};